import { Link } from "react-router-dom";
import { ArrowUpRight, Clock } from "lucide-react";
import { EnquiryDialog } from "./EnquiryDialog";

export function PackageCard({ pkg }) {
  return (
    <div className="group flex flex-col bg-cream border border-emerald/10 hover:-translate-y-1 hover:shadow-xl hover:shadow-black/5 transition-all duration-300 h-full" data-testid={`package-card-${pkg.slug}`}>
      <Link to={`/packages/${pkg.slug}`} className="relative overflow-hidden h-60 block">
        <img src={pkg.image} alt={pkg.title} className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
        <span className="absolute top-4 left-4 bg-cream/90 backdrop-blur text-emerald text-xs uppercase tracking-widest px-3 py-1.5 flex items-center gap-1.5"><Clock className="w-3 h-3" /> {pkg.duration}</span>
        {pkg.featured && <span className="absolute top-4 right-4 bg-gold text-white text-[0.6rem] uppercase tracking-widest px-3 py-1.5">Most Popular</span>}
      </Link>
      <div className="p-7 flex flex-col flex-1">
        <p className="eyebrow text-gold mb-2">{pkg.tagline}</p>
        <h3 className="font-serif text-2xl text-emerald leading-tight">{pkg.title}</h3>
        <div className="flex flex-wrap gap-2 mt-4">
          {pkg.highlights.slice(0, 3).map((h) => (
            <span key={h} className="text-xs text-ink/60 border border-emerald/15 px-2.5 py-1 rounded-full">{h}</span>
          ))}
        </div>
        <div className="mt-auto pt-6 flex items-end justify-between">
          <div>
            <p className="text-ink/40 text-xs uppercase tracking-wider">Price</p>
            <p className="font-serif text-xl text-emerald">{pkg.price}</p>
          </div>
          <Link to={`/packages/${pkg.slug}`} className="flex items-center gap-1 text-emerald hover-underline text-sm font-medium" data-testid={`view-package-${pkg.slug}`}>Details <ArrowUpRight className="w-4 h-4" /></Link>
        </div>
        <EnquiryDialog title={`Book · ${pkg.title}`} presetPackage={pkg.title} presetType="Booking" trigger={
          <button className="mt-5 w-full bg-emerald text-cream py-3 text-xs uppercase tracking-[0.2em] font-semibold hover:bg-gold transition-colors" data-testid={`book-package-${pkg.slug}`}>Enquire Now</button>
        } />
      </div>
    </div>
  );
}
